import { render, staticRenderFns } from "./AdminNewtons.vue?vue&type=template&id=d66ff1b2&scoped=true&"
import script from "./AdminNewtons.vue?vue&type=script&lang=js&"
export * from "./AdminNewtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66ff1b2",
  null
  
)

export default component.exports